// Frame de produto com print REAL da plataforma SalonUP.
export const PhoneShot = ({ src, alt, label, className = "", priority = false }) => (
  <figure className={`relative ${className}`}>
    <div className="overflow-hidden rounded-[1.75rem] border border-charcoal/10 bg-white shadow-[0_32px_90px_-36px_rgba(31,31,31,0.28)] md:rounded-[2.25rem]">
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        className="block h-auto w-full"
      />
    </div>
    {label && (
      <figcaption className="absolute -top-3 left-5 rounded-full border border-charcoal/[0.08] bg-white/95 px-3.5 py-1.5 text-xs font-medium text-charcoal/75 shadow-sm backdrop-blur">
        {label}
      </figcaption>
    )}
  </figure>
);
